import httpClient from "./httpClient";

const END_POINT = "/api/prematriculas";

const getByCurso = (idCurso) =>
  httpClient.get(`${END_POINT}/intranet`, {
    params: { curso: idCurso, pagination: false },
  });

const getById = async (idPrematricula) =>
  await httpClient.get(`${END_POINT}/${idPrematricula}`);

const update = async (item, params) => {
  let idPrematricula = item.prematricula.id || null;

  if (idPrematricula == null) {
    throw new Error("No es posible actualizar la prematricula, ID es nulo.");
  }

  return await httpClient.put(`${END_POINT}/${idPrematricula}`, {
    ...params,
  });
};

const sendEmails = async (item) => {
  let idPrematricula = item.prematricula.id || null;
  let email = item.tutor.email || null;

  if (idPrematricula == null) {
    throw new Error(
      "No es posible enviar los emails, el identificador de prematricula es nulo."
    );
  }

  if (email == null || email == "") {
    throw new Error(
      "No es posible enviar los emails, el email del solicitante el nulo o está vacio."
    );
  }

  return await httpClient.get(`${END_POINT}/${idPrematricula}/send-mails`);
};

const remove = async (item) => {
  let idPrematricula = item.id || null;
  if (idPrematricula == null) {
    throw new Error(
      "No es posible borrar la prematricula, el identificador es nulo."
    );
  }

  return await httpClient.delete(`${END_POINT}/${idPrematricula}`);
};

/**
 * Accion de asignar niveles a los alumnos nuevos|antiguos
 * que no tengan asignado nivel en las prematriculas.
 *
 * No es necesario pasarle el curso como parametro, se encarga el backend, lo obtiene de base de datos.
 *
 */
const asignarNivelesAlumnos = async (tipo) => {
  let tipoEndPoint = null;

  switch (tipo) {
    case "nuevos":
      tipoEndPoint = "set-nivel-nuevos";
      break;

    case "antiguos":
      tipoEndPoint = "set-nivel-antiguos";
      break;
  }

  if (tipoEndPoint == null) {
    throw new Error(
      `No es posible asignar niveles, el tipo: ${tipo} no existe.`
    );
  }

  const currentEndPoint = `${END_POINT}/${tipoEndPoint}`;
  return await httpClient.get(currentEndPoint);
};

/**
 * Matricular
 */
const matricular = async (params) => {
  return await httpClient.post(`${END_POINT}/matriculate`, {
    ...params,
  });
};

/**
 * Obtener el numero máximo del campo orden de las prematriculas del curso actual
 */
const getNumeroMaximoSorteo = async () => {
  return await httpClient.get(`${END_POINT}/get-numero-maximo-sorteo`, {
    params: { pagination: false },
  });
};

export {
  getByCurso,
  getById,
  update,
  sendEmails,
  remove,
  asignarNivelesAlumnos,
  matricular,
  getNumeroMaximoSorteo,
};
